export const GUESTUSER = "guest_user";
export const GUESTRFQ = "GUESTRFQ";
export const GUESTRFQTOTAL = "GUESTRFQTOTAL";
export const GUESTRFQ_STORAGE = "guest_rfq";

// Guest Invite Types
export const GUEST_INVITE_TYPE = {
	RFX_SUPPLIER: 1,
	RFX_PRE_APPROVER: 2,
};
